// Utility functions for testing the complete beacon workflow

/**
 * Reset all beacon-related states to simulate a first-time user
 */
export const resetBeaconWorkflow = () => {
  // Clear all beacon-related localStorage items
  localStorage.removeItem('tour_import_data_clicked');
  localStorage.removeItem('tour_open_panneau_clicked');
  localStorage.removeItem('tour_/talent/dataimport');
  localStorage.removeItem('tour_/talent/dataimport_completed');
  localStorage.removeItem('first_time_updated');
  localStorage.removeItem('tour_completed_event_dispatched');
  localStorage.removeItem('first_time_updating');
  localStorage.removeItem('first_time_last_update');
  localStorage.removeItem('user_first_time_checked');
  localStorage.removeItem('user_is_first_time');
  
  console.log('Beacon workflow reset complete');
};

/**
 * Simulate the complete beacon workflow
 */
export const simulateBeaconWorkflow = () => {
  // Step 1: Reset all states
  resetBeaconWorkflow();
  
  // Step 2: Set user as first-time user
  localStorage.setItem('user_is_first_time', 'true');
  localStorage.setItem('user_first_time_checked', 'true');
  
  console.log('Beacon workflow simulation started');
  console.log('1. User is now a first-time user');
  console.log('2. Navigate to any /talent/* route (except /talent/dataimport) to see the first beacon');
  console.log('3. Click the beacon to navigate to /talent/dataimport');
  console.log('4. On the DataImport page, a second beacon should appear on the "Open Panneau" button');
  console.log('5. Click that beacon to open the panel and start the tour');
};

/**
 * Check the current state of the beacon workflow
 */
export const checkBeaconWorkflowState = () => {
  const state = {
    importDataClicked: localStorage.getItem('tour_import_data_clicked') === 'true',
    openPanneauClicked: localStorage.getItem('tour_open_panneau_clicked') === 'true',
    tourCompleted: localStorage.getItem('tour_/talent/dataimport') === 'true',
    firstTimeUpdated: localStorage.getItem('first_time_updated') === 'true',
    userIsFirstTime: localStorage.getItem('user_is_first_time') === 'true',
    userFirstTimeChecked: localStorage.getItem('user_first_time_checked') === 'true'
  };
  
  console.log('Beacon Workflow State:', state);
  return state;
};

/**
 * Manually trigger the first beacon click
 */
export const triggerFirstBeaconClick = () => {
  localStorage.setItem('tour_import_data_clicked', 'true');
  console.log('First beacon click triggered');
  console.log('Navigate to /talent/dataimport to see the second beacon');
};

/**
 * Manually trigger the second beacon click
 */
export const triggerSecondBeaconClick = () => {
  localStorage.setItem('tour_open_panneau_clicked', 'true');
  console.log('Second beacon click triggered');
  console.log('The tour should now start if implemented correctly');
};

// Expose functions globally for easy testing from browser console
window.beaconTest = {
  reset: resetBeaconWorkflow,
  simulate: simulateBeaconWorkflow,
  checkState: checkBeaconWorkflowState,
  triggerFirstBeacon: triggerFirstBeaconClick,
  triggerSecondBeacon: triggerSecondBeaconClick
};

console.log('Beacon workflow test utilities loaded. Use window.beaconTest to access functions.');
console.log('Available functions:');
console.log('- window.beaconTest.reset() // Reset all beacon states');
console.log('- window.beaconTest.simulate() // Simulate complete beacon workflow');
console.log('- window.beaconTest.checkState() // Check current beacon workflow state');
console.log('- window.beaconTest.triggerFirstBeacon() // Manually trigger first beacon click');
console.log('- window.beaconTest.triggerSecondBeacon() // Manually trigger second beacon click');